import React from "react";

export default function Dialog(props: {
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
}): React.ReactNode {
  const dialog = React.useRef<HTMLDialogElement | null>(null);

  function onClick(event: React.MouseEvent<HTMLDialogElement, MouseEvent>) {
    const { clientX, clientY, target } = event;
    if (!(target instanceof HTMLDialogElement)) return;

    // HTMLDialogElement boundaries with padding and border
    const { left, right, top, bottom } = target.getBoundingClientRect();
    const clickedOnBackdrop =
      clientX < left || right < clientX || clientY < top || bottom < clientY;
    if (clickedOnBackdrop) handleClose();
  }

  function handleClose() {
    props.onClose();

    if (!dialog || dialog.current == null) return;

    dialog.current.close();
  }

  React.useEffect(() => {
    if (!dialog) return;

    if (props.open && dialog.current) {
      dialog.current.showModal();
    } else {
      handleClose();
    }
  });

  return (
    <dialog
      ref={dialog}
      onClick={onClick}
      className="p-3 shadow rounded backdrop:backdrop-blur-sm self-center justify-self-center"
    >
      <div className="flex gap-2 flex-col">{props.children}</div>
    </dialog>
  );
}
